<template>
  <div>
    <v-tooltip
        bottom
        :disabled="!isTooltipVisible"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
            v-on="on"
            v-bind="attrs"
            @mouseover="onMouseOver"
            @mouseleave="onMouseLeave"
        >
          <v-layout
              :id="'post-assessment-selection-' + contentItem.name"
              class="flex items-start gap-3 p-4 rounded-lg border treatment-row-container cursor-pointer"
              :class="{ 'is-disabled': isDisabled }"
              @click="handleSelect"
          >
            <div>
              <div class="treatment-primary-cell">
                <v-icon
                    v-if="isChecklist"
                    size="20"
                    color="primary"
                    class="item-checkbox"
                >
                  {{ checkboxIcon }}
                </v-icon>
                <mrx-translation
                    v-if="contentItem.headerToken"
                    class="treatment-header"
                    :token="contentItem.headerToken"
                />
              </div>
              <div v-for="(item, index) in contentItem.detailContent"
                   :key="item+'_'+index"
              >
                <mrx-translation
                    v-if="!contentItem.useHTMLFormat"
                    class="assessment-light" :class="(contentItem.headerToken) ? 'treatment-text' : 'treatment-header'"
                    :token="item"
                ></mrx-translation>
                <span v-else class="assessment-light" :class="(contentItem.headerToken) ? 'treatment-text' : 'treatment-header'" v-html="item"></span>
              </div>
            </div>
          </v-layout>
        </div>
      </template>
      <span v-if="isDisabled">
        <mrx-translation :token="disabledItems[contentItem.name].token"></mrx-translation>
      </span>
    </v-tooltip>
    <v-divider
      v-if="!isLast"
      class="me-3"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import MrxTranslation from "@/components/thinkmd/mrx/translation.vue";
import type { DisabledItemsMap, TreatmentContentItem } from "@/features/overall-assessment/types/overall-assessment.types";

export default defineComponent({
  name: "TreatmentRow",
  components: { MrxTranslation },
  props: {
    contentItem: { type: Object as PropType<TreatmentContentItem>, required: true },
    isChecklist: { type: Boolean, default: false },
    isLast: { type: Boolean, default: false },
    disabledItems: { type: Object as PropType<DisabledItemsMap>, default: () => ({}) },
    checkboxIcon: { type: String, default: "" }
  },
  data() {
    return {
      isTooltipVisible: false
    };
  },
  computed: {
    isDisabled(): boolean {
      return !!this.disabledItems[this.contentItem.name];
    }
  },
  methods: {
    onMouseOver() {
      this.isTooltipVisible = this.isDisabled;
    },
    onMouseLeave() {
      this.isTooltipVisible = false;
    },
    handleSelect() {
      this.$emit("select", this.contentItem.name);
    }
  }
});
</script>
